import MicroModal from 'micromodal';
import { forEachPolyfill } from './functions';

MicroModal.init();
forEachPolyfill();

export function cartProcess(el) {
    
    // don't run function if not on product page
    if(!document.querySelector(el)) return;

    // set variables
    const radios = document.querySelectorAll('input[type="radio"]');
    const steps = document.querySelectorAll('.wc-pao-addon');
    const prevBtn = document.querySelector('.link#prev');
    const nextBtn = document.querySelector('.btn#next');
    const cartBtn = document.querySelector('button[name="add-to-cart"]');
    let i = 0;
    steps[0].classList.add('current');

    // Loop over radio buttons and add class to parent <label> when checked
    radios.forEach((radio) => {
        radio.parentNode.classList.add('radio-container');
        radio.addEventListener('click', () => {
            let current = document.getElementsByClassName('active');
            if(current.length) {
                current[0].className = current[0].className.replace(" active", "");            
            }
            radio.parentNode.className += " active";
        });
    });

    // set initial progress state
    const setProgress = (i) => {
        const progress = document.querySelector('.modal-progress');
        const items = steps.length;
        for (let i = 0; i < items; i++) {
            let newItem = document.createElement('p');
            let node = document.createTextNode(i+1);
            if(i===0) {
                newItem.classList = 'modal-progress__item modal-progress__item--active';
            } else {
                newItem.classList = 'modal-progress__item';
            }
            newItem.appendChild(node);
            progress.appendChild(newItem);
        }
        updateProgress(i);
    };

    // update the state with new index
    const updateProgress = (i) => {
        // update the progress bar (dots)
        const progressItems = document.querySelectorAll('.modal-progress__item');
        progressItems[i].classList.add('modal-progress__item--active');

        // show the current product-addon div
        steps[i].classList.add('current');
        
        // hide prev if the first step and hide next if it's the last step
        if (i === 0) { prevBtn.style.visibility = "hidden"; } else { prevBtn.style.visibility = "visible"; }
        if (i === steps.length-1) { 
            nextBtn.style.visibility = "hidden"; 
            cartBtn.style.display = "inline-block";
        } else { 
            nextBtn.style.visibility = "visible"; 
            cartBtn.style.display = "none";
        }
        
        // get all input fields from current step
        const stepItems = steps[i].querySelectorAll('input');

        // disable button if there's no radio selected on a requried step
        if(!checkIfRequired(steps[i])) {
            nextBtn.setAttribute('disabled', 'disabled');
            cartBtn.setAttribute('disabled', 'disabled');
        }
        stepItems.forEach((item) => {
            item.addEventListener('click', () => {
                nextBtn.removeAttribute('disabled');
                cartBtn.removeAttribute('disabled');
            });
        });
    };

    // check if a form field is required and, if so, disable the button
    const checkIfRequired = (item) => {
        if (!item.classList.contains('wc-pao-required-addon')) {
            return true;
        } else {
            const requiredItems = item.querySelectorAll('input');
            let status = false;
            requiredItems.forEach((item) => {
                if(item.checked === true) {
                    status = true;
                }
            });
            return status;
        }
    };
    
    setProgress(i);

    prevBtn.addEventListener('click', () => {
        steps[i].classList.remove('current');
        i--;
        updateProgress(i);        
    });
    nextBtn.addEventListener('click', () => {
        if(!checkIfRequired(steps[i])) return;
        steps[i].classList.remove('current');
        i++;
        updateProgress(i);
    });
    cartBtn.addEventListener('click', (e) => {        
        if (!checkIfRequired(steps[i])) e.preventDefault();
    });
}